// extracted by mini-css-extract-plugin
var _1 = "LargeTooltip-module__animateUploadProgressBarWidth--HEtbm";
var _2 = "LargeTooltip-module__animatedBackground--ISZ1O";
var _3 = "LargeTooltip-module__heading--g8mKE";
var _4 = "LargeTooltip-module__inner--ZIBI5";
var _5 = "LargeTooltip-module__withPadding--pwUyd";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "heading", _4 as "inner", _5 as "withPadding" }
